<template>
	<div>
		<h1 v-if="node_workflow && node_workflow.description">{{node_workflow.description}}</h1>
		<h1 v-else>Type de données</h1>

        <p v-if="node_workflow && node_workflow.long_description">{{ node_workflow.long_description }}</p>

        <b-select v-model="type_data_start" :options="[
            {value: 'tabulator', text: 'Tableau'},
            {value: 'database', text: 'Base de données'},
            {value: 'DatabaseRequestView', text: 'Base de données - multitables'},				
            {value: 'files_upload', text: 'Fichiers'}
        ]" />

        <br /><br />

        <div v-if="type_data_start == 'tabulator'">
            <edit_tabulator
                @update="import_file(false)"
                ref="start_tabulator"
                :hidden="true"
            ></edit_tabulator>
            <edit_tabulator_conditions
                ref="start_tabulator_conditions"
                :data="start_data"
                @update="import_file_conditions"
            ></edit_tabulator_conditions>
        </div>
        <div v-if="type_data_start == 'DatabaseRequestView'">
            <DatabaseRequestView 
                @update="import_file(false)"
                _type="db"
                :minimal="true"
                ref="start_tabulator" />
        </div>
        <div v-if="type_data_start == 'files_upload'">
            <file_upload 
                :upload="false"
                @update="import_file(false)"
                ref="start_tabulator" />
        </div>
        <div v-if="type_data_start == 'database'">
            <database
                @update="import_file(false)"
                :change_table="true"
                :name="false"
                :edit="false"
                ref="start_tabulator"></database>
        </div>
	</div>
</template>

<script>
	var XLSX = require("xlsx");
	var clone = require("clone");
	
    import * as json2csv from "json2csv";
    import uniqueId from "lodash.uniqueid";

	import edit_tabulator_conditions from "../components/edit_tabulator_conditions.vue";
	import DatabaseRequestView from '../views/DatabaseRequestView.vue';
	import edit_tabulator from "../components/edit_tabulator.vue";
	import file_upload from "../components/file_upload.vue";
	import treatments from "../services/treatments.js";
	import databaseView from "../views/database.vue";

	export default {
		name: "data_component",
		components: {
            edit_tabulator_conditions,
            DatabaseRequestView,
            edit_tabulator,
            file_upload,
            databaseView
		},
		data() {
			return {
                type_data_start: "tabulator",
                start_data: []
			};
		},
        watch: {
            type_data_start() {
                var self = this;
                this.$nextTick(() => {
                    self.$emit("set_data_in", self.workflow);
                });
            }
        },
		props: {
			node_workflow: {
				default: () =>  null
			},
			worflow_builder: {
				default: false
			},
            workflow: {
                default: null
            }
        },
		methods: {
			async parse_file(file) {
				const reader = new FileReader();
				reader.readAsText(file);
				const result = await new Promise((resolve, reject) => {
					reader.onload = function (event) {
						resolve(reader.result);
					};
				});
				return result;
			},
			async parse_file_array_buffer(file) {
				const reader = new FileReader();
				reader.readAsArrayBuffer(file);
				const result = await new Promise((resolve, reject) => {
					reader.onload = function (event) {
						resolve(reader.result);
					};
				});
				return result;
			},
			async save_workflow()
			{
				var data = {
                    type_data_start: this.type_data_start,
                    data: this.$refs.start_tabulator.save()
                };

				return data;
			},
			async load_workflow(data)
			{
                this.type_data_start = data.type_data_start;

                await this.$nextTick();

                if (data.data)
                    await this.$refs.start_tabulator.load(data.data)
			},
			import_file(add, data = null)
			{
                console.log("import_file")
                if (this.type_data_start == "tabulator")
                {
					data = this.$refs.start_tabulator.get_data();
                    this.start_data = data;
                }

                this.$emit("set_data_in", this.workflow);
			},
			import_file_conditions(add, data = null)
			{                
                this.$emit("set_data_in", this.workflow);
			},
            async file_to_csv(data, filename)
            {
                if (filename && filename.endsWith(".xlsx"))
                {
                    data = await this.parse_file_array_buffer(data);

                    var workbook = XLSX.read(data, { bookType: "csv", dateNF:'yyyy-mm-dd'});
                    data = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], {raw:false, defval: ""});
                }
                else if (filename)
                {						
                    data = await this.parse_file(data);

                    data = this.$papa.parse(data, { header: true });
                    data = data.data;
                }
                else
                    data = [];

                return data;
            },
            async get_data_in()
            {
                if (this.type_data_start == "tabulator")
                {
                    var data = await this.$parent.get_data_in(this.workflow);

                    if (data.length > 0)
                    {
                        if (data[0].type == "csv")
                        {
                            data = await this.parse_file(data[0].data);

                            data = this.$papa.parse(data, { header: true });
                            data = data.data;
                        }
                        else if (data[0] instanceof File)
                        {
                            data = data[0];
                            
                            var filename = data.name || data.upload.filename;

                            data = await this.file_to_csv(data, filename);
                        }
                        else
                        {
                            let filename = data[0].name;

                            var data = await treatments.getFileAlyx(
                                data[0].url,
                                false,
    							"blob"
                            );
                            
                            data = await this.file_to_csv(data, filename);
                        }
                    }
                    else
                        data = [];
                    this.start_data = data;
                }
            },
            async get_data_out()
            {
                var files_out = [];
                if (this.type_data_start == "tabulator")
                {
                    var data = await this.$refs.start_tabulator_conditions.get_data_blob();

                    files_out.push({
                        name: "data.csv",
                        type: "csv",
                        data: data
                    });
                }
                else if (this.type_data_start == "files_upload")
                {
                    files_out = await this.$refs.start_tabulator.get_data_files();
                }
                else
                {
                    var data = await this.$refs.start_tabulator.get_data_blob();
                    files_out.push({
                        name: "data.csv",
                        type: "csv",
                        data: data
                    });
                }

                return files_out;
            }
		},
		mounted: async function () {
		},
	};
</script>
